import {
	PRODUCT_TYPE_EVO,
	PRODUCT_TYPE_NOVA
} from '../../dashboard/product-filter';

export const STATISTICS_SERIAL_BATCH_SIZE = 250;

export const getStatisticsProductIDs = productType => {
	switch (parseInt(productType)) {
		case PRODUCT_TYPE_EVO:
			return [PRODUCT_TYPE_EVO];
		case PRODUCT_TYPE_NOVA:
			return [PRODUCT_TYPE_NOVA];
		default:
			return [PRODUCT_TYPE_EVO, PRODUCT_TYPE_NOVA, 3];
	}
};

export const normalizeStatisticsSerialNumbers = serialNumbers => {
	const serialList = Array.isArray(serialNumbers)
		? serialNumbers
		: String(serialNumbers || '').split(',');

	return Array.from(new Set(
		serialList
			.map(serialNumber => String(serialNumber || '').trim())
			.filter(Boolean)
	));
};

export const getStatisticsMarketKits = marketType => {
	switch (parseInt(marketType)) {
		case 1:
			return ['US'];
		case 2:
			return ['Demo'];
		case 3:
			return ['Intl'];
		case 4:
			return ['US', 'Intl', 'Brazil'];
		case 5:
			return ['Brazil'];
		default:
			return null;
	}
};

export const getStatisticsDeviceSerialNumbers = (devices, marketType) => {
	const marketKits = getStatisticsMarketKits(marketType);
	const filteredDevices = marketKits
		? (devices || []).filter(device => marketKits.includes(device.Kit))
		: (devices || []);

	return normalizeStatisticsSerialNumbers(filteredDevices.map(device => device.SerialNumber));
};

export const chunkStatisticsSerialNumbers = (serialNumbers, batchSize = STATISTICS_SERIAL_BATCH_SIZE) => {
	const normalizedSerialNumbers = normalizeStatisticsSerialNumbers(serialNumbers);
	const chunks = [];

	for (let index = 0; index < normalizedSerialNumbers.length; index += batchSize) {
		chunks.push(normalizedSerialNumbers.slice(index, index + batchSize));
	}

	return chunks;
};
